import React from 'react'
import {
    Box,
    Flex,
    Icon,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'

const ProductRegistrationCard = ({icon, variant, description, datatestid}) => {
    const styles = useMultiStyleConfig('ProductRegistration', {variant})
    return (
        <Flex {...styles.singleCardContainer} data-testid={datatestid}>
            <Box {...styles.cardInnerContainer}>
                <Icon as={icon} {...styles.cardIcon} />
                <Box {...styles.cardDescriptionContainer}>
                    <Text {...styles.cardDescription}>{description}</Text>
                </Box>
            </Box>
        </Flex>
    )
}

ProductRegistrationCard.propTypes = {
    icon: PropTypes.elementType,
    description: PropTypes.node,
    variant: PropTypes.string,
    datatestid: PropTypes.string,
}

export default ProductRegistrationCard
